import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Btn } from '../../models/button/button';
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.clickBtn = new EventEmitter();
    }
    ButtonComponent.prototype.onClick = function (e) {
        this.clickBtn.emit(e);
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'item-btn',
                    template: "<button type=\"{{ btn.type || 'button' }}\" [disabled]=\"btn.disabled\" (click)=\"onClick(btn.event)\" [key]=\"key\" [btn]=\"btn\" buttonDir>{{ btn.caption }}</button>",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    ButtonComponent.propDecorators = {
        key: [{ type: Input }],
        btn: [{ type: Input }],
        clickBtn: [{ type: Output }]
    };
    return ButtonComponent;
}());
export { ButtonComponent };
//# sourceMappingURL=button.component.js.map